import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { Sidebar } from '@/components/Sidebar';
import { TopBar } from '@/components/TopBar';
import { useChordShortcuts } from '@/lib/useChordShortcuts';

type RouterContext = { queryClient: QueryClient };

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  useChordShortcuts();
  return (
    <div className="flex h-screen min-h-0 bg-zinc-950 text-zinc-100">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-1.5 focus:rounded-md focus:bg-indigo-500 focus:text-white focus:text-sm"
      >
        Skip to content
      </a>
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main id="main" className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-screen-2xl px-4 md:px-6 lg:px-8 py-5">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
